import React, { useMemo } from 'react'
import RadioInput from 'LuxKit/Radio/RadioInput'
import useExperiencesSortOptions from '../hooks/useExperiencesSortOptions'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import { rem } from 'polished'

const RadioGroup = styled(Group)`
  padding-inline: ${rem(16)};
`

const SortOption = styled(RadioInput)`
  display: flex;
  width: 100%;
  padding-block: ${rem(1)};
  cursor: pointer;
  touch-action: manipulation;
`

function ExperiencesSortByOptions() {
  const { setSortBy, sortBy, sortOptions } = useExperiencesSortOptions()
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSortBy(e.target.value as Experiences.SortTypes)
  }
  const options = useMemo(() => Object.entries(sortOptions), [sortOptions])

  return (
    <RadioGroup direction="vertical" gap={16}>
      {options.map(([key, option]) => <SortOption
        key={key}
        id={`experience-sort-by-${key}`}
        checked={sortOptions[sortBy]?.label === option.label}
        onChange={onChange}
        name="experience-sort-by"
        value={key}
      >
        {option.label}
      </SortOption>)}
    </RadioGroup>
  )
}

export default ExperiencesSortByOptions
